/**
 * «روزِ محصول» — تصمیم بنیادی سند: روز کاربر ساعت ۴ بامداد تمام می‌شود، نه نیمه‌شب.
 * کسی که ساعت ۱:۳۰ بامداد عادتش را ثبت می‌کند، هنوز در «دیروز» است.
 * هر جای اپ و ربات و سرور که به تاریخ نیاز دارد باید از همین‌جا بگیرد.
 */
export const DAY_START_HOUR = 4;
const pad = (n) => String(n).padStart(2, "0");
export function toISO(d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
/** تاریخ روزِ محصول برای یک لحظهٔ مشخص (پیش‌فرض: الان) */
export function productDay(at = new Date()) {
    const d = new Date(at);
    d.setHours(d.getHours() - DAY_START_HOUR);
    return toISO(d);
}
/** لحظه‌ای که روزِ محصولِ جاری تمام می‌شود — برای شمارش معکوس «تا آخر روز» */
export function endOfProductDay(at = new Date()) {
    const [y, m, d] = productDay(at).split("-").map(Number);
    return new Date(y, m - 1, d + 1, DAY_START_HOUR, 0, 0, 0);
}
export function addDays(iso, n) {
    const [y, m, d] = iso.split("-").map(Number);
    return toISO(new Date(y, m - 1, d + n));
}
export function daysBetween(a, b) {
    const [ay, am, ad] = a.split("-").map(Number);
    const [by, bm, bd] = b.split("-").map(Number);
    const ms = Date.UTC(by, bm - 1, bd) - Date.UTC(ay, am - 1, ad);
    return Math.round(ms / 86_400_000);
}
/** شنبهٔ هفتهٔ همان روز */
export function startOfWeek(iso) {
    const [y, m, d] = iso.split("-").map(Number);
    const js = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
    return addDays(iso, -((js + 1) % 7));
}
/** هفت روز هفتهٔ جاری، از شنبه */
export function weekDays(iso) {
    const s = startOfWeek(iso);
    return Array.from({ length: 7 }, (_, i) => addDays(s, i));
}
/** N روز گذشته تا امروز (شامل امروز) */
export function lastNDays(iso, n) {
    return Array.from({ length: n }, (_, i) => addDays(iso, -(n - 1 - i)));
}
/** حالت نورپردازی اتاق سهیل */
export function timeOfDay(at = new Date()) {
    const h = at.getHours();
    if (h >= 5 && h < 16)
        return "morning";
    if (h >= 16 && h < 20)
        return "evening";
    return "night";
}
//# sourceMappingURL=day.js.map